<template>
  <div class="card shadow-sm p-4">
    <!--h5 class="card-title text-center mb-3">{{ $t("movement_details") }}</h5-->

    <div class="row">
      <div v-for="(field, index) in fields" :key="index" class="col-md-6 d-flex align-items-center mb-2">
        <label class="fw-bold d-flex align-items-center flex-shrink-0 w-50">
          <i :class="field.icon" class="me-2"></i> {{ field.label }}
        </label>
        <p class="form-control-plaintext m-0 w-50" :class="field.label === $t('totalPrix') ? 'text-success' : ''">
          <template v-if="field.isBadge">
            <span class="badge" :class="field.value ? 'bg-success' : 'bg-danger'">
              {{ field.value ? 'Yes' : 'No' }}
            </span>
          </template>
          <template v-else>
            {{ field.value || '-' }}
          </template>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    movement: {
      type: Object,
      required: true,
    },
  },
  computed: {
    fields() {
      return [
        //{ label: this.$t("id"), value: this.movement.id, icon: "bi bi-hash" },
        //{ label: this.$t("type"), value: this.movement.e_s === "in" ? "Incoming" : "Outgoing", icon: "bi bi-arrow-left-right" },
        //{ label: this.$t("date"), value: this.movement.date, icon: "bi bi-calendar" },
        //{ label: this.$t("nombre"), value: this.movement.nombre, icon: "bi bi-list-ol" },

        // Show "Source" if e_s = "in", otherwise show "Destination"
        this.movement.e_s === "in"
          ? { label: this.$t("source"), value: this.movement.source || "-", icon: "bi bi-box" }
          : { label: this.$t("destination"), value: this.movement.destination || "-", icon: "bi bi-geo-alt" },
        
        { label: this.$t("poidTot"), value: `${this.movement.poidTot} kg`, icon: "bi bi-weight" },
        
        { label: this.$t("remarque"), value: this.movement.remarque || "-", icon: "bi bi-chat-left-text" },

        { label: this.$t("prixTot"), value: `${this.movement.prixTot} €`, icon: "bi bi-cash" },

        { label: this.$t("addDetailExpense"), value: this.movement.addDetailExpense, icon: "bi bi-receipt", isBadge: true },

        { label: this.$t("totalExpenses"), value: `${this.movement.totalExpenses || "0"} €`, icon: "bi bi-credit-card" },

        { label: this.$t("addDetailMovement"), value: this.movement.addDetailMovement, icon: "bi bi-box-seam", isBadge: true },
        
        
        
        { label: this.$t("totalPrix"), value: `${this.movement.totalPrix || "0"} €`, icon: "bi bi-wallet2" },

        { label: this.$t("costPerLivestock"), value: `${this.movement.costPerLivestock || "0"} €`, icon: "bi bi-wallet2" },

        { label: this.$t("costPerKilo"), value: `${this.movement.costPerKilo || "0"} Kg`, icon: "bi bi-wallet2" },
      ];
    },
  },
};
</script>

<style scoped>
.card {
  background-color: #f8f9fa;
  border-radius: 10px;
}
.form-control-plaintext {
  font-weight: 600;
  padding: 6px;
  background: #fff;
  border-radius: 5px;
}
.fw-bold {
  color: #333;
}
.badge {
  font-size: 1rem;
  padding: 5px 10px;
}
.d-flex {
  display: flex;
  justify-content: space-between;
}
</style>
